/* eslint-disable no-useless-catch */
import { API } from "../api";
import { CLIENT_ADDRESS } from "../constants/url.constant";

export const GET_CLIENT_ADDRESSES = "GET_CLIENT_ADDRESSES";
export const ADD_CLIENT_ADDRESS = "ADD_CLIENT_ADDRESS";
export const DELETE_CITY = "DELETE_CITY";
export const UPDATE_CITY = "UPDATE_CITY";

export const getClientAddresses = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(CLIENT_ADDRESS, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_CLIENT_ADDRESSES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addClientAddress = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CLIENT_ADDRESS, data);
      dispatch({
        type: ADD_CLIENT_ADDRESS,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

// export const updateCity = (code, body) => {
//   return async (dispatch) => {
//     try {
//       await API.put(`${CITIES_URL}/${code}`, body);
//       dispatch({ type: UPDATE_CITY, payload: { code, ...body } });
//     } catch (error) {
//       throw error;
//     }
//   };
// };

// export const removeCity = (cityCode) => {
//   return async (dispatch) => {
//     try {
//       const res = await API.delete(`${CITIES_URL}/${cityCode}`);
//       dispatch({
//         type: DELETE_CITY,
//         payload: cityCode
//       });
//       return res;
//     } catch (error) {
//       throw error;
//     }
//   };
// };

export default function reducer(
  state = { clientAddressRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_CLIENT_ADDRESSES:
      return {
        ...state,
        clientAddressColumns: payload.columns,
        clientAddressRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_CLIENT_ADDRESS:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        clientAddressRows: [...state.clientAddressRows, { ...payload }]
      };
    case DELETE_CITY:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        clientAddressRows: state.clientAddressRows.filter(
          (hub) => hub.code !== payload
        )
      };
    case UPDATE_CITY:
      return {
        ...state,
        clientAddressRows: state.clientAddressRows.map((city) =>
          city.code === payload.code
            ? {
              "hub.region.country.name": city["hub.region.country.name"],
              ...payload
            }
            : city
        )
      };
    default:
      return state;
  }
}
